export default __webpack_public_path__ + "static/media/kubernetes.2649cae2.svg";